import { FlexBox, Colors, PostFixWrapper, NavbarLogoName, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { createGlobalStyle, css } from "styled-components";

export const SimpleLogoContainer = styled(FlexBox)<{ isMedia?: boolean}>`
`;

export const LogoWrapper = styled.div`
  ${PostFixWrapper} {
    padding-top: 0;
  }
  
  ${NavbarLogoName} {
    padding-top: 0;

    @media (max-width: ${LayoutConst.screen.l}px) {
      margin-left: 0!important;
    }

  }
`

export const LogoWrapperWhite = styled.div<any>`
  ${p => p.isKiiidsArt && css`
    div {
      margin-left: 0;
    }
      svg {
        ${p.isOpen? css`
          rect, path {
            stroke: #94209E;
          }
        `
        : 
         css`rect {
          fill: #94209E;
        }`}
      }
    `}
  div {
      ${p => p.isDeziiignMain && 'color: #ff0000;' }
      ${p => p.fontWeight && `font-weight: ${p.fontWeight};`}
  }
  ${NavbarLogoName} {
    @media (max-width: ${LayoutConst.screen.l}px) {
      margin-left: 0!important;
    }
  }
`

export const DafesStyles = createGlobalStyle`

  ${LogoWrapper} div, ${LogoWrapper} span {
    font-family: Inter;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: ${Colors.galBlack100} !important;

    @media (max-width: ${LayoutConst.screen.m}px) {
      font-size: 17px;
      line-height: 22px;
    }
  }

  ${LogoWrapper} span {
    margin-left: 8px;
  }
`;

export const CompetitionNavigationTab = styled.div<{ isActive?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  place-items: center;
  padding: 12px 0 12px 0px;
  border-bottom: 1px solid ${p => p.isActive ? Colors.geoWhite100 : Colors.galBlack47};
  background-color: transparent;
  color: ${p => p.isActive ? Colors.geoWhite100 : Colors.galBlack47};
  font-size: 20px;
  line-height: 25px;
  font-weight: 600;
  text-decoration: none;
  justify-content: space-between;

  // .edit-icon-wrapper {
  //   margin-left: 100%;
  // }

  svg:not(.edit-icon) {
    width: 16px;
    height: 12px;

    path {
      stroke: ${p => p.isActive ? Colors.geoWhite100 : Colors.galBlack47};
    }
  }

  &:hover {
    color: ${p => p.isActive ? Colors.geoWhite100 : Colors.geoWhite100};
    border-bottom: 1px solid ${p => p.isActive ? Colors.geoWhite100 : Colors.geoWhite100};

    .edit-icon-wrapper {
      opacity: 1 !important;
    }

    svg path {
      stroke: ${p => p.isActive ? Colors.geoWhite100 : Colors.geoWhite100};
    }
  }

  ${({ isActive }) => isActive && css`
    border-bottom: 1px solid ${Colors.geoWhite100};
    color: ${Colors.geoWhite100};

    .folder-name {
      color: ${Colors.geoWhite100};
    }
  `}
`;import { FlexBox, Colors, PostFixWrapper, NavbarLogoName, MEDIA } from "@brg/ui";
import { LayoutConst } from "core";
import styled, { createGlobalStyle, css } from "styled-components";

export const SimpleLogoContainer = styled(FlexBox)<{ isMedia?: boolean}>`
`;

export const LogoWrapper = styled.div`
  ${PostFixWrapper} {
    padding-top: 0;
  }
  
  ${NavbarLogoName} {
    padding-top: 0;

    @media (max-width: ${LayoutConst.screen.l}px) {
      margin-left: 0!important;
    }

  }
`

export const LogoWrapperWhite = styled.div<any>`
  ${p => p.isKiiidsArt && css`
    div {
      margin-left: 0;
    }
      svg {
        ${p.isOpen? css`
          rect, path {
            stroke: #94209E;
          }
        `
        : 
         css`rect {
          fill: #94209E;
        }`}
      }
    `}
  div {
      ${p => p.isDeziiignMain && 'color: #ff0000;' }
      ${p => p.fontWeight && `font-weight: ${p.fontWeight};`}
  }
  ${NavbarLogoName} {
    @media (max-width: ${LayoutConst.screen.l}px) {
      margin-left: 0!important;
    }
  }
`

export const DafesStyles = createGlobalStyle`

  ${LogoWrapper} div, ${LogoWrapper} span {
    font-family: Inter;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    color: ${Colors.galBlack100} !important;

    @media (max-width: ${LayoutConst.screen.m}px) {
      font-size: 17px;
      line-height: 22px;
    }
  }

  ${LogoWrapper} span {
    margin-left: 8px;
  }
`;

export const CompetitionNavigationTab = styled.div<{ isActive?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  place-items: center;
  padding: 12px 0 12px 0px;
  border-bottom: 1px solid ${p => p.isActive ? Colors.geoWhite100 : Colors.galBlack47};
  background-color: transparent;
  color: ${p => p.isActive ? Colors.geoWhite100 : Colors.galBlack47};
  font-size: 20px;
  line-height: 25px;
  font-weight: 600;
  text-decoration: none;
  justify-content: space-between;

  // .edit-icon-wrapper {
  //   margin-left: 100%;
  // }

  svg:not(.edit-icon) {
    width: 16px;
    height: 12px;

    path {
      stroke: ${p => p.isActive ? Colors.geoWhite100 : Colors.galBlack47};
    }
  }

  &:hover {
    color: ${p => p.isActive ? Colors.geoWhite100 : Colors.geoWhite100};
    border-bottom: 1px solid ${p => p.isActive ? Colors.geoWhite100 : Colors.geoWhite100};

    .edit-icon-wrapper {
      opacity: 1 !important;
    }

    svg path {
      stroke: ${p => p.isActive ? Colors.geoWhite100 : Colors.geoWhite100};
    }
  }

  ${({ isActive }) => isActive && css`
    border-bottom: 1px solid ${Colors.geoWhite100};
    color: ${Colors.geoWhite100};

    .folder-name {
      color: ${Colors.geoWhite100};
    }
  `}
`;